<!-- <app-loader></app-loader> -->
<div class="layout__wrapper">
  <div class="sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <main class="main_container">
    <app-page-header [data]="pageHeader"></app-page-header>
    <router-outlet></router-outlet>
    <!-- Guest Search -->
    <!-- <button
      class="sos_sidekick_active_btn"
      [appRelativeClickPosition]="sosNotesInfo"
      [disabled]="!isDeviceLoaded"
    >
      <img src="/assets/icons/SOS (1).svg" alt="SIDEKICK CONNECTED" />
    </button> -->
    <!-- <button
      [ngClass]="
        isSidekickConnected ? 'guest_sidekick_active_btn' : 'guest_sidekick_btn'
      "
      [appRelativeClickPosition]="roomNotesInfo"
      [disabled]="!isDeviceLoaded"
    >
      <img
        *ngIf="!isSidekickConnected"
        src="/assets/icons/sidekick-icon.svg"
        alt="SIDEKICK SETUP"
      />
      <img
        *ngIf="isSidekickConnected"
        src="/assets/icons/sidekick-icon-light.svg"
        alt="SIDEKICK CONNECTED"
      />
    </button>
    <button class="guest_search_btn" (click)="openGuestProfiles()">
      <img src="/assets/icons/g_search.svg" alt="Guest Search" />
    </button> -->
  </main>
</div>